<div class="row" style="padding: 15px">
  <div>
    <p-table
      [columns]="columns"
      [value]="emailDelegation"
      [paginator]="true"
      [first]="pageNumber"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      [reorderableColumns]="true"
      sortMode="multiple"
      [loading]="isTableLoading"
      [loadingIcon]="''"
      [resizableColumns]="true"
      columnResizeMode="expand"
      derableColumns="true"
      [editable]="true"
      (onPage)="onPageChange($event)"
      [dataKey]="'id'"
    >
      <ng-template pTemplate="paginatorright">
        <div class="p-text-right">
          <label for="perPage" class="p-mr-2">Rows per page:</label>
          <select id="perPage" class="p-inputtext" (change)="onRowsChange($event)">
            <option *ngFor="let option of rowsOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="text-align: center !important" scope="col">
            <button mat-icon-button color="primary" (click)="addNewRow()" [disabled]="isAnyRowBeingEdited">
              <mat-icon>add</mat-icon>
            </button>
          </th>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn scope="col">
            <div class="top-div">
              <div class="text-section">
                <span [pSortableColumn]="col.field">{{ col.title }}</span>
              </div>
              <div class="spacer"><p-sortIcon [field]="col.field" /></div>
            </div>
            <div class="bottom-div">
              <p-columnFilter [field]="col.field" matchMode="in" [showMenu]="false" (onClear)="customClear(col)">
                <ng-template pTemplate="filter">
                  <p-multiSelect
                    [options]="col.filterOptions"
                    placeholder="Select"
                    [(ngModel)]="filters[col.field]"
                    [optionLabel]="'label'"
                    appendTo="body"
                    (onChange)="customFilter(col.type)"
                    [panelStyle]="{ 'z-index': '1000' }"
                  >
                    <ng-template let-option pTemplate="item">
                      <div class="inline-block vertical-align-middle">
                        <span class="ml-1 mt-1">{{ option["label"] }}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
              <button class="clear-button" mat-icon-button *ngIf="filters[col.field]?.length || col.advancefilter.isAdvanceFilterUsed" (click)="customClear(col)">
                <mat-icon class="clear-button-icon">close</mat-icon>
              </button>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-selected="selected" let-i="rowIndex">
        <tr
          [pSelectableRow]="rowData"
          [class.selected-row]="selected"
          [ngClass]="{ 'p-highlight': isSelected(i) }"
          (click)="onRowClick($event, i)"
          (mousedown)="onMouseDown($event, i)"
          (mouseover)="onMouseOver($event, i)"
          (mouseup)="onMouseUp()"
          (keydown)="onRowKeydown($event, i)" 
          (focus)="onRowFocus($event, i)"
        >
          <td style="text-align: center !important">
              <ng-container *ngIf="editingEmailDelegationRows[i]; else showEditBtn">
                <button mat-icon-button color="primary" (click)="saveRow(i)">
                  <mat-icon>save</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="cancelSave(i)">
                  <mat-icon>cancel</mat-icon>
                </button>
              </ng-container>
              <ng-template #showEditBtn>
                <button *ngIf="!rowData[i]?.isNew" mat-icon-button color="accent" (click)="editRow(i)" [disabled]="isAnyRowBeingEdited">
                  <mat-icon>edit</mat-icon>
                </button>
                <button *ngIf="!rowData[i]?.isNew" mat-icon-button color="accent" (click)="deleteRow(i)" [disabled]="isAnyRowBeingEdited">
                  <mat-icon>delete</mat-icon>
                </button>
              </ng-template>
          </td>
          <td *ngFor="let col of columns">
            <ng-container>
              <ng-container *ngIf="editingEmailDelegationRows[i]; else readOnlyCell">
                <ng-container [ngSwitch]="col.type">
                  <ng-container *ngSwitchCase="'number'">
                    <input
                      type="number"
                      pInputText
                      [placeholder]="'Enter ' + col.title"
                      [(ngModel)]="rowData[col.field]"
                      #fieldRef="ngModel"
                      [disabled]="col.disabled"
                      required
                      (mousedown)="$event.stopPropagation()"
                    />
                    <div *ngIf="fieldRef.invalid && (fieldRef.touched || validationTouched[i])" class="p-error">
                      <span style="white-space: normal" *ngIf="fieldRef.errors?.['required']">
                        {{ col.title }} is required.
                      </span>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'date'">
                    <p-calendar
                      [(ngModel)]="rowData[col.field]"
                      [placeholder]="'Select ' + col.title"
                      [disabled]="col.disabled"
                      (mousedown)="$event.stopPropagation()"
                      #fieldRef="ngModel"
                      (onSelect)="onDateSelect($event, rowData, col.field)"
                      appendTo="body"
                      [required]="col.required"
                      [dateFormat]="'dd/mm/yy'"
                    >
                    </p-calendar>
                    <div *ngIf="fieldRef.invalid && (fieldRef.touched || validationTouched[i])" class="p-error">
                      <span style="white-space: normal" *ngIf="fieldRef.errors?.['required']">
                        {{ col.title }} is required.
                      </span>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'email'">
                    <p-dropdown
                      [(ngModel)]="rowData[col.field]"
                      [options]="filteredGpids"
                      optionLabel="name"
                      optionValue="value"
                      [placeholder]="'Enter ' + col.title"
                      [minLength]="1"
                      [filter]="true"
                      [showClear]="true"
                      appendTo="body"
                      [required]="col.required"
                      [disabled]="!isNewRowBeingEdited && col.disabled"
                      #toAddressAutocomplete="ngModel"
                    ></p-dropdown>
                    <div *ngIf="toAddressAutocomplete.invalid && (toAddressAutocomplete.touched || validationTouched[i])" class="p-error">
                      <span style="white-space: normal" *ngIf="toAddressAutocomplete.errors?.['required']">
                        {{ col.title }} is required.
                      </span>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <input
                      style="width: -webkit-fill-available"
                      [required]="col.required"
                      [placeholder]="'Enter ' + col.title"
                      [(ngModel)]="rowData[col.field]"
                      pInputText
                      [required]="col.required"
                      [disabled]="col.field === 'system' || col.field === 'name' || (!isNewRowBeingEdited && col.disabled)"
                      #fieldRef="ngModel"
                      (mousedown)="$event.stopPropagation()"
                    />
                    <div *ngIf="fieldRef.invalid && (fieldRef.touched || validationTouched[i])" class="p-error">
                      <span style="white-space: normal" *ngIf="fieldRef.errors?.['required']">
                        {{ col.title }} is required.
                      </span>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #readOnlyCell>
                <ng-container>
                  {{ rowData[col.field] }}
                </ng-container>
              </ng-template>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns.length" class="p-text-center text-muted"
            style="padding: 1rem;text-align: center !important;">
            No data available
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
